import { render, staticRenderFns } from "./ApplicantApplicationDetail.vue?vue&type=template&id=0834612f&scoped=true&"
import script from "./ApplicantApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantApplicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantApplicationDetail.vue?vue&type=style&index=0&id=0834612f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834612f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSkeletonLoader,VSnackbar,VTextField,VTextarea})
